import React from 'react';
import { InstagramIcon, YoutubeIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-800 text-white py-12" data-id="element-178">
      <div className="container mx-auto px-4" data-id="element-179">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-180">
          <div data-id="element-181">
            <h3 className="text-xl font-bold mb-4" data-id="element-182">Special Performances</h3>
            <p className="text-gray-300 mb-4" data-id="element-183">
              A supportive music collective for musicians with autism and
              intellectual disabilities.
            </p>
            <div className="flex space-x-4" data-id="element-184">
              <a href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-185">
                <InstagramIcon size={20} data-id="element-186" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-187">
                <YoutubeIcon size={20} data-id="element-188" />
              </a>
            </div>
          </div>
          <div data-id="element-189">
            <h3 className="text-xl font-bold mb-4" data-id="element-190">Quick Links</h3>
            <ul className="space-y-2" data-id="element-191">
              <li data-id="element-192">
                <a href="#about" className="text-gray-300 hover:text-white transition-colors" data-id="element-193">
                  About Us
                </a>
              </li>
              <li data-id="element-194">
                <a href="#features" className="text-gray-300 hover:text-white transition-colors" data-id="element-195">
                  Our Program
                </a>
              </li>
              <li data-id="element-196">
                <a href="#faq" className="text-gray-300 hover:text-white transition-colors" data-id="element-197">
                  FAQ
                </a>
              </li>
              <li data-id="element-198">
                <a href="#contact" className="text-gray-300 hover:text-white transition-colors" data-id="element-199">
                  Join Us
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-200">
            <h3 className="text-xl font-bold mb-4" data-id="element-201">Contact Us</h3>
            <div className="space-y-3" data-id="element-202">
              <div className="flex items-center" data-id="element-203">
                <MailIcon size={20} className="mr-3 text-indigo-400" data-id="element-204" />
                <span className="text-gray-300" data-id="element-205">
                  info@specialperformances.org
                </span>
              </div>
              <div className="flex items-center" data-id="element-206">
                <PhoneIcon size={20} className="mr-3 text-indigo-400" data-id="element-207" />
                <span className="text-gray-300" data-id="element-208">(609) 469-2263</span>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-12 pt-6 text-center text-gray-400 text-sm" data-id="element-209">
          <p data-id="element-210">
            &copy; {new Date().getFullYear()} Special Performances Music Collective - Special Interest Group. All rights
            reserved.
          </p>
          <p className="mt-1" data-id="element-211">
            <a href="https://specialperformances.org" className="hover:text-white transition-colors" data-id="element-212">
              specialperformances.org
            </a>
          </p>
        </div>
      </div>
    </footer>;
}